import { useMoviesStore } from "@multicines/stores";
import { Modal } from "artisn-ui-react";
import CloseSVG from "images/close.svg";
import { useRouter } from "next/router";
import React, { useState } from "react";

import Styles from "./TicketsHeader.styles";
import { TicketsHeaderProps as Props } from "./TicketsHeader.types";
import Close from "../Close/Close";
import GoBack from "../GoBack/GoBack";
import Timeout from "../Timeout/Timeout";
import Timer from "../Timer/Timer";
import CartButton from "../navigation/CartButton/CartButton";
import useI18n from "hooks/useI18n";

const TicketsHeader: React.FC<Props> = props => {
  const { className, showTimer = true, canClose } = props;
  const { canGoBack = true, step, text } = props;
  const { showCart, isCart, onClose, goBackTo, onGoBack } = props;
  const t = useI18n();
  const [opened, setOpened] = useState(false);
  const setIsSessionExpired = useMoviesStore(
    store => store.setIsSessionExpired
  );
  const reservationExpiration = useMoviesStore(
    store => store.reservationExpiration
  );
  const { back } = useRouter();

  const closeHandler = () => {
    back();
  };

  const sessionExpirationHandler = () => {
    setIsSessionExpired(true);
    setOpened(true);
  };

  return (
    <>
      <Styles className={`TicketsHeader ${className}`}>
        {canGoBack ? (
          <GoBack
            className="TicketsHeader__go-back"
            title={text}
            to={goBackTo}
            onGoBack={onGoBack}
          />
        ) : null}
        {isCart ? (
          <div onClick={onClose}>
            <GoBack
              className="TicketsHeader__go-back"
              title={text}
              to="/cart"
            />
          </div>
        ) : null}
        <div className="TicketsHeader__status">
          {step === "choose-tickets" ? (
            <>
              <div className="TicketsHeader__step" />
              <div className="TicketsHeader__stepEmpty" />
            </>
          ) : null}
          {step === "choose-seats" ? (
            <>
              <div className="TicketsHeader__step" />
              <div className="TicketsHeader__step" />
            </>
          ) : null}
        </div>
        {showTimer ? (
          <div className="TicketsHeader__timer">
            {!opened && reservationExpiration ? (
              <>
                <p className="TicketsHeader__timer__title">
                  {t.common.remainingTime}
                </p>
                <Timer onFinish={sessionExpirationHandler} />
              </>
            ) : null}
          </div>
        ) : null}
        {showCart ? <CartButton /> : null}
        {canClose ? (
          <Close className="TicketsHeader__close" onClick={onClose} />
        ) : null}
      </Styles>
      <Modal
        closeOnClickOutside={false}
        opened={opened}
        backdropConfig={{
          onClick: closeHandler
        }}
        onClose={closeHandler}
        closeIcon={<CloseSVG />}
        color="transparent"
      >
        <Timeout />
      </Modal>
    </>
  );
};

export default TicketsHeader;
